<script setup lang="ts">
import {
  PhArrowRight as ArrowRightIcon,
  PhPalette as PaletteIcon,
  PhRuler as RulerIcon,
  PhWrench as WrenchIcon,
} from '@phosphor-icons/vue'
import type { Product } from '../types'
import ProductImage from './ProductImage.vue'

defineProps<{ product: Product }>()

function formatBasePrice(value: number) {
  return new Intl.NumberFormat('zh-CN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)
}
</script>

<template>
  <article class="product-card">
    <RouterLink :to="`/products/${product.slug}`" class="product-card__image-link">
      <ProductImage
        :src="product.image"
        :alt="`${product.name}柜体展示图`"
        :position="product.imagePosition"
      />
    </RouterLink>
    <div class="product-card__body">
      <div>
        <span class="category-label">
          {{ product.secondaryCategory ? `${product.category} / ${product.secondaryCategory}` : product.category }}
        </span>
        <h3>
          <RouterLink :to="`/products/${product.slug}`">{{ product.name }}</RouterLink>
        </h3>
        <p>{{ product.summary }}</p>
      </div>
      <div class="customization-list" aria-label="支持的定制项">
        <span v-if="product.colorsEnabled !== false"><PaletteIcon :size="17" />颜色</span>
        <span><RulerIcon :size="17" />尺寸</span>
        <span v-if="product.hardwareEnabled !== false"><WrenchIcon :size="17" />五金</span>
      </div>
      <div class="product-card__footer">
        <p
          v-if="product.basePriceYuan != null && Number.isFinite(product.basePriceYuan) && product.basePriceYuan > 0"
          class="product-card__price"
        >
          参考价 ¥{{ formatBasePrice(product.basePriceYuan) }}起
        </p>
        <RouterLink class="text-link" :to="`/products/${product.slug}`">
          查看定制范围
          <ArrowRightIcon :size="17" aria-hidden="true" />
        </RouterLink>
      </div>
    </div>
  </article>
</template>
